import { useId } from "react";

import { stringToBoolean } from "@/lib/chillnn/string-to-boolean";

import { Checkbox } from "@/components/ui/input/checkbox";

import { FormErrorMessage, FormItem } from "../../../_base/form";

import type { CheckedState } from "@radix-ui/react-checkbox";

type CheckboxFieldProps = {
	value: boolean;
	label: string;
	handleChange: (input: boolean) => void;

	errorMessage?: string | undefined;
};

export const CheckboxField = ({ value, label, handleChange, errorMessage }: CheckboxFieldProps): JSX.Element => {
	const uniqueID = useId();

	const handleChangeLocal = (input: CheckedState) => {
		const value = typeof input === "string" ? stringToBoolean(input) : input;

		handleChange(value);
	};

	return (
		<FormItem>
			<div className="flex items-center gap-x-3">
				{/* Noto Sans JP は ascent と descent が非対称で、字面の中心が行ボックスの中心より約 1px 下に来る。同じ分だけ下げて字面にそろえる */}
				<Checkbox
					className="translate-y-[1px]"
					defaultChecked={value}
					checked={value}
					onCheckedChange={handleChangeLocal}
					id={uniqueID}
				/>
				<label className="font-normal" htmlFor={uniqueID}>
					{label}
				</label>
			</div>
			<FormErrorMessage>{errorMessage}</FormErrorMessage>
		</FormItem>
	);
};
